import ENV from "../config/config";

const URL_PREFIX = ENV === "main" ? "" : ENV + ".";

//added port
let URL = "https://" + URL_PREFIX + "aionos-backend.verismart.ai";

if (ENV === "main") {
  URL = "https://smartexchange-be.ioh.id";
}

if (ENV === "uat") {
  URL = "https://backend-se.gammasprint.com";
}

const BASE_URL = {
  adn_api: {
    url: URL,
    version: "/api/v1/aionos",
  },
  cpass_api: {
    url: URL,
    version: "/v1/cpass",
  },
  insights_api: {
    url: "https://" + URL_PREFIX + "backend-adn.metawing.ai",
    version: "/v1/insights",
  },
};

export default BASE_URL;
